import conf from '../conf';
import { getTotalCost as avataxSignupCalculator } from './buy-flow';

import type { AbandonedData } from '@avalara/types/marketing';
import type { State } from '@avalara/types/reducer-states';

type AuiType = typeof import('@avalara/aui');

export const costCalculator = (state: State): number => {
  switch (state.system.activeFlow) {
    case 'avatax-buy':
    case 'avatax-direct-buy':
      return avataxSignupCalculator(state.buyFlow);
    default:
      return 0;
  }
};

export const captureAbandonedSignup = (options: AbandonedData) => {
  window.navigator.sendBeacon(`${conf.API_URL}/api/abandoned`, JSON.stringify(options));
};

export const getReturnsPagename = () => {
  const { href, pathname, search } = window.location;

  if (!/returns/.test(href)) return '';

  const type = new URLSearchParams(search).get('type');

  const returnsType = type === 'sb' ? 'SB' : 'MR';

  const subcategory = pathname.substring(pathname.lastIndexOf('/') + 1).replace('-', ' ');
  const category = subcategory !== 'returns' ? subcategory.replace(/\s+/g, '-') : 'setup';

  return `buydot | returns-${returnsType}-${category}`.toLowerCase();
};

export const getAuthLogin = (): string => `/auth/login?returnUrl=${encodeURIComponent(document.location.toString())}`;

export const getAuthLogout = (): string => `/auth/logout?returnUrl=${encodeURIComponent(document.location.toString())}`;

const getUrlSearchParams = () => new URLSearchParams(window.location.search);
export const embeddedViewRequested = (): boolean => getUrlSearchParams().get('embedded') === 'true';

export const openExternalLink = (url: string) =>
  embeddedViewRequested() ? window.open(url, '_blank', 'noopener noreferrer') : window.location.assign(url);

export const checkIsAuthenticated = (): boolean => {
  const auiUser = (window.aui as AuiType)?.user;
  return !!auiUser?.isLoggedIn || !!window.AvaAppUser?.isLoggedIn;
};

export const isProdEnv = (): boolean => window.AvaAppConfig?.env === 'prd';

export const getWindowQueryUnlessInProd = () => (isProdEnv() ? '' : window.location.search);

export const getAccessToken = async (): Promise<{ accessToken: string }> => {
  const response = await fetch('api/access-token');
  if (!response.ok) return { accessToken: 'NO_ACCESS' };
  return response.json();
};
